import { KeyLabel, MOD } from './KeyLabel';
export const KeyLabelHungarian: KeyLabel[] = [
  {
    code: 4,
    label: 'A',
    meta: [
      {
        label: 'ä',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 5,
    label: 'B',
    meta: [
      {
        label: '{',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 6,
    label: 'C',
    meta: [
      {
        label: '&',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 7,
    label: 'D',
    meta: [
      {
        label: 'Đ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 8,
    label: 'E',
    meta: [
      {
        label: 'Ä',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 9,
    label: 'F',
    meta: [
      {
        label: '[',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 10,
    label: 'G',
    meta: [
      {
        label: ']',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 11,
    label: 'H',
  },
  {
    code: 12,
    label: 'I',
  },
  {
    code: 13,
    label: 'J',
  },
  {
    code: 14,
    label: 'K',
    meta: [
      {
        label: 'ł',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 15,
    label: 'L',
    meta: [
      {
        label: 'Ł',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 16,
    label: 'M',
  },
  {
    code: 17,
    label: 'N',
    meta: [
      {
        label: '}',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 18,
    label: 'O',
  },
  {
    code: 19,
    label: 'P',
  },
  {
    code: 20,
    label: 'Q',
    meta: [
      {
        label: '(backslash)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 21,
    label: 'R',
  },
  {
    code: 22,
    label: 'S',
    meta: [
      {
        label: 'đ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 23,
    label: 'T',
  },
  {
    code: 24,
    label: 'U',
    meta: [
      {
        label: '€',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 25,
    label: 'V',
    meta: [
      {
        label: '@',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 26,
    label: 'W',
    meta: [
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 27,
    label: 'X',
    meta: [
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 28,
    label: 'Z',
  },
  {
    code: 29,
    label: 'Y',
    meta: [
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 30,
    label: '1',
    meta: [
      {
        label: "'",
        modifiers: MOD.SFT,
      },
      {
        label: "'",
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '~',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 31,
    label: '2',
    meta: [
      {
        label: '"',
        modifiers: MOD.SFT,
      },
      {
        label: '"',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: 'ˇ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 32,
    label: '3',
    meta: [
      {
        label: '+',
        modifiers: MOD.SFT,
      },
      {
        label: '+',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '^ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 33,
    label: '4',
    meta: [
      {
        label: '!',
        modifiers: MOD.SFT,
      },
      {
        label: '!',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '˘ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 34,
    label: '5',
    meta: [
      {
        label: '%',
        modifiers: MOD.SFT,
      },
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '° (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 35,
    label: '6',
    meta: [
      {
        label: '/',
        modifiers: MOD.SFT,
      },
      {
        label: '/',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '˛ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 36,
    label: '7',
    meta: [
      {
        label: '=',
        modifiers: MOD.SFT,
      },
      {
        label: '=',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '`',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 37,
    label: '8',
    meta: [
      {
        label: '(',
        modifiers: MOD.SFT,
      },
      {
        label: '(',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '˙ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 38,
    label: '9',
    meta: [
      {
        label: ')',
        modifiers: MOD.SFT,
      },
      {
        label: ')',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '´ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 39,
    label: 'Ö',
    meta: [
      {
        label: '˝ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 45,
    label: 'Ü',
    meta: [
      {
        label: '¨ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 46,
    label: 'Ó',
    meta: [
      {
        label: '¸ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 47,
    label: 'Ő',
    meta: [
      {
        label: '÷',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 48,
    label: 'Ú',
    meta: [
      {
        label: '×',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 50,
    label: 'Ű',
    meta: [
      {
        label: '¤',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 51,
    label: 'É',
    meta: [
      {
        label: '$',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 52,
    label: 'Á',
    meta: [
      {
        label: 'ß',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 53,
    label: '0',
    meta: [
      {
        label: '§',
        modifiers: MOD.SFT,
      },
      {
        label: '§',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 54,
    label: ',',
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: ';',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 55,
    label: '.',
    meta: [
      {
        label: ':',
        modifiers: MOD.SFT,
      },
      {
        label: ':',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 56,
    label: '-',
    meta: [
      {
        label: '_',
        modifiers: MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '*',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 100,
    label: 'Í',
    meta: [
      {
        label: '<',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 542,
    label: "'",
  },
  {
    code: 543,
    label: '"',
  },
  {
    code: 544,
    label: '+',
  },
  {
    code: 545,
    label: '!',
  },
  {
    code: 546,
    label: '%',
  },
  {
    code: 547,
    label: '/',
  },
  {
    code: 548,
    label: '=',
  },
  {
    code: 549,
    label: '(',
  },
  {
    code: 550,
    label: ')',
  },
  {
    code: 565,
    label: '§',
  },
  {
    code: 566,
    label: '?',
  },
  {
    code: 567,
    label: ':',
  },
  {
    code: 568,
    label: '_',
  },
  {
    code: 4638,
    label: "'",
  },
  {
    code: 4639,
    label: '"',
  },
  {
    code: 4640,
    label: '+',
  },
  {
    code: 4641,
    label: '!',
  },
  {
    code: 4642,
    label: '%',
  },
  {
    code: 4643,
    label: '/',
  },
  {
    code: 4644,
    label: '=',
  },
  {
    code: 4645,
    label: '(',
  },
  {
    code: 4646,
    label: ')',
  },
  {
    code: 4661,
    label: '§',
  },
  {
    code: 4662,
    label: '?',
  },
  {
    code: 4663,
    label: ':',
  },
  {
    code: 4664,
    label: '_',
  },
  {
    code: 5124,
    label: 'ä',
  },
  {
    code: 5125,
    label: '{',
  },
  {
    code: 5126,
    label: '&',
  },
  {
    code: 5127,
    label: 'Đ',
  },
  {
    code: 5128,
    label: 'Ä',
  },
  {
    code: 5129,
    label: '[',
  },
  {
    code: 5130,
    label: ']',
  },
  {
    code: 5134,
    label: 'ł',
  },
  {
    code: 5135,
    label: 'Ł',
  },
  {
    code: 5137,
    label: '}',
  },
  {
    code: 5140,
    label: '(backslash)',
  },
  {
    code: 5142,
    label: 'đ',
  },
  {
    code: 5144,
    label: '€',
  },
  {
    code: 5145,
    label: '@',
  },
  {
    code: 5146,
    label: '|',
  },
  {
    code: 5147,
    label: '#',
  },
  {
    code: 5149,
    label: '>',
  },
  {
    code: 5150,
    label: '~',
  },
  {
    code: 5151,
    label: 'ˇ (dead)',
  },
  {
    code: 5152,
    label: '^ (dead)',
  },
  {
    code: 5153,
    label: '˘ (dead)',
  },
  {
    code: 5154,
    label: '° (dead)',
  },
  {
    code: 5155,
    label: '˛ (dead)',
  },
  {
    code: 5156,
    label: '`',
  },
  {
    code: 5157,
    label: '˙ (dead)',
  },
  {
    code: 5158,
    label: '´ (dead)',
  },
  {
    code: 5159,
    label: '˝ (dead)',
  },
  {
    code: 5165,
    label: '¨ (dead)',
  },
  {
    code: 5166,
    label: '¸ (dead)',
  },
  {
    code: 5167,
    label: '÷',
  },
  {
    code: 5168,
    label: '×',
  },
  {
    code: 5170,
    label: '¤',
  },
  {
    code: 5171,
    label: '$',
  },
  {
    code: 5172,
    label: 'ß',
  },
  {
    code: 5174,
    label: ';',
  },
  {
    code: 5176,
    label: '*',
  },
  {
    code: 5220,
    label: '<',
  },
];
